






import Vue from 'vue'
import CreateForm from '@/components/Newsletters/CreateForm/CreateForm.vue'
export default Vue.extend({
  components: {
    CreateForm
  }
})
